import clsx from 'clsx'
import React, { FC, ForwardedRef, forwardRef } from 'react'
import { Stack, SxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

const Root = styled(Stack)`
  height: 100%;
  overflow: hidden;
  text-align: right;
  position: relative;
`

const Body = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  overflow: 'hidden auto',
  backgroundColor: theme.palette.veryVeryLightGray,
}))

const FABWrapper = styled('div')`
  position: absolute;
  bottom: 0;
  left: 12px;
    
  transition:
    bottom 0.3s ease,
    opacity 0.2s ease;
    
  opacity: 0;
  pointer-events: none;
    
  &.visible {
    bottom: 12px;
    opacity: 1;
    pointer-events: auto;
  }
`

interface Props {
  appBar: JSX.Element
  children: React.ReactNode
  // eslint-disable-next-line react/require-default-props
  rootSx?: SxProps
  // eslint-disable-next-line react/require-default-props
  bodySx?: SxProps
  bodyClass?: string
  FAB?: FC<{}>
  isFABVisible?: boolean
}

export const PageWithAppBar = forwardRef(function PageWithAppBarComponent(
  {
    appBar,
    children,
    rootSx = null,
    bodySx = null,
    bodyClass,
    FAB,
    isFABVisible = true,
  }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <Root sx={rootSx} ref={ref}>
      {appBar}

      <Body className={bodyClass} sx={bodySx}>
        {children}
      </Body>

      {FAB ? (
        <FABWrapper className={clsx({ visible: isFABVisible })}>
          <FAB />
        </FABWrapper>
      ) : undefined}
    </Root>
  )
})
